module.exports = __webpack_public_path__ + "static/media/22.e133bf8c.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/22.JPG
// module id = 465
// module chunks = 0